<div *ngIf="auth.authenticated && auth?.user?.textRepliesAccess;else other_content;">

  <h2>Email Replies</h2>
  <br />
  <p *ngIf="!allEmailReplies"><em>Loading...</em></p>

  <div *ngIf="allEmailReplies" class=" ">
    <table class='table'>
      <thead>
        <tr>
          <th style="text-align: center">Index</th>
          <th style="text-align: center">Account Number</th>
          <th>Response</th>
          <th style="text-align: center">Email Address</th>
          <th style="text-align: center">DateTime Received</th>
          <th style="text-align: center">Work Queue</th>
          <th style="text-align: center">Done?</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let emailReplies of allEmailReplies; let isOdd=odd; let i=index;">
          <tr [class.odd]="isOdd">
            <td style="text-align: center">
              {{ i + 1 }}
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-default" (click)='popScreen(emailReplies)'>{{ emailReplies.accountNumber }}</button>
            </td>
            <td>
              {{ emailReplies.response }}
            </td>
            <td style="text-align: center">
              {{ emailReplies.email }}
            </td>
            <td style="text-align: center">
              {{ emailReplies.dateTimeReceived | date: 'MM/dd/yyyy hh:mm a' }}
            </td>
            <td style="text-align: center">
              {{ emailReplies.workQueue }}
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-success" (click)='updateDatabase(emailReplies)'>Done</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #other_content>
  <div *ngIf="!auth.authenticated; else unauthorized;">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div class="replies">
      <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
    </div>

    <br />
    <br />
    <br />
    <br />

    <div class="replies">
      <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
    </div>

  </div>
  <ng-template #unauthorized>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
  </ng-template>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/email-replies/email-replies.component.html